import classnames from "classnames";
import { navigationPropType } from "@template/state/modules/navigation";
import NavAnchor from "@template/components/Navigation/NavAnchor";
import padlock from "./assets/padlock-purple.svg";
import styles from "../index.css";
import { useSelector } from "react-redux";
import { getLoyaltyStatus } from "@template/state/modules/loyalty";
import { EARLY_ACCESS_TO_NEW_IN_BENEFIT_TYPE } from "@src/client/navigation/constants";

const cx = classnames.bind(styles);

const TextList = ({ item }) => {
  const { optedIn: isOptedInToLoyalty, isAvailable: isLoyaltyAvailable } =
    useSelector(getLoyaltyStatus);

  return (
    <ul aria-labelledby={item.id} className={styles.textList}>
      {item.items.map((navItem, index) => {
        const asosWorldCategory =
          navItem.loyaltyBenefitType === EARLY_ACCESS_TO_NEW_IN_BENEFIT_TYPE;

        return (
          <li key={navItem.id}>
            <NavAnchor
              className={cx(styles.textLink, {
                [styles.textLink__sale]:
                  navItem.largeScreenStyleType === "sale",
                [styles.textLink__bold]:
                  navItem.largeScreenStyleType === "premium",
                [styles.textLink__asosWorld]:
                  asosWorldCategory && isLoyaltyAvailable
              })}
              item={navItem}
              data-testid="text-link"
              data-first={item.isFirstColumn && index === 0 ? true : null}
              data-last={
                item.isLastColumn && index === item.items.length - 1
                  ? true
                  : null
              }
            >
              {navItem.label.substring(0, 32)}
              {asosWorldCategory &&
                isLoyaltyAvailable &&
                !isOptedInToLoyalty && (
                  <img
                    src={padlock}
                    className={styles.padlock}
                    alt="Lock icon"
                  />
                )}
            </NavAnchor>
          </li>
        );
      })}
    </ul>
  );
};

TextList.propTypes = {
  item: navigationPropType.isRequired
};

export default TextList;
